<!-- <div class="row">
<input class="form-control" [placeholder]="placeholderText" (keyup)="onKeypressEvent($event)" [value]="autoSearchDafaultValue" type="text" autocomplete="off">
</div>
<input  #autoCompleteInput name="question" id="inputField" [placeholder]="placeholderText" (keyup)="onKeypressEvent($event)" [value]="autoSearchDafaultValue" type="text" autocomplete="off">
-->
<div id="autocomplete-wrapper">
  <div id="autocomplete-input">
    <!-- <textarea #autoCompleteInput  name="question" id="inputField" [placeholder]="placeholderText" (keyup)="onKeypressEvent($event)" [(ngModel)]="autoSearchDafaultValue" type="text" autocomplete="off" ariea-multiple="true"></textarea> -->
    @if (selectedTags.length > 0) {
    <div class="tags-wrapper">
      @for (tag of selectedTags; track tag; let i = $index) {
      <span class="tag">
        {{ tag }}
        <span class="tag-close" (click)="removeTag(tag)">×</span>
      </span>
      }
    </div>
    }
    <textarea
      #autoCompleteInput
      name="question"
      id="inputField"
      [placeholder]="selectedTags.length > 0 ? '' : placeholderText"
      (keyup)="onKeypressEvent($event)"
      (keydown.enter)="onEnterKeyDown($event)"
      [(ngModel)]="singleTag"
      type="text"
      autocomplete="off"
      ariea-multiple="true"
    >
    </textarea>
  </div>
  @if (suggestionEnable) {
  <div id="suggestion-list" [hidden]="!showSearches">
    <div class="search">
      @for (data of searchedList; track trackById($index, data)) {
      <div
        (click)="setSelected(data)"
        class="search-result"
        [innerHTML]="data | searchHighlight : singleTag"
      ></div>
      }
    </div>
    @if (searchedList.length == 0 && singleTag!='') {
    <p class="search">No Data found</p>
    }
  </div>
  }
</div>
<!-- <div id="autocomplete-wrapper">
<div id="autocomplete-input">
  <div #autoCompleteInput id="inputField" contenteditable="true" aria-multiline="true" role="textbox"
  [attr.placeholder]="placeholderText" (keyup)="onKeypressEvent($event)" class="editable-input"></div>
</div>

<ng-container *ngIf="suggestionEnable">
  <div id="suggestion-list" [hidden]="!showSearches">
    <div class="search">
      <div *ngFor="let data of searchedList; trackBy: trackById" (click)="setSelected(data)" class="search-result"
      [innerHTML]="data | searchHighlight : autoSearchDafaultValue"></div>
    </div>
    <p class="search" *ngIf="searchedList.length == 0 && autoSearchDafaultValue != ''">No Data found</p>
  </div>
</ng-container>
</div> -->
